import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
@Component({
  selector: 'app-pay-outbatchviewdetails',
  templateUrl: './pay-outbatchviewdetails.component.html',
  styleUrls: ['./pay-outbatchviewdetails.component.scss']
})
export class PayOutbatchviewdetailsComponent implements OnInit {
  // rows = [];
  PayOutBatchId:any;
  MerchantKeyId:any;
  PayoutTransactionId:any;
  TransactionType:any;
  PaymentType:any;
  TransactionAmount:any;
  Id:any;
  viewid:any;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService) { 
    this.route.params.subscribe(params => {
      this.viewid = params['id'];
    });
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.ViewPayOutBatchViewdetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => { 
      // this.rows=result;
      this.TransactionAmount=result.TransactionAmount;
      this.PaymentType=result.PaymentType;
      this.PayOutBatchId=result.PayOutBatchId;
      this.MerchantKeyId=result.MerchantKeyId;
      this.PayoutTransactionId=result.PayoutTransactionId;
     this. TransactionType=result.TransactionType;
    });
  }

  ngOnInit() {
  }

}
